import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ROLE_LABELS } from "../lib/constants";
import { useSettings } from "../context/SettingsContext";
import { Truck, PackageCheck, Store, ReceiptText, Users, Euro, ShoppingCart } from "lucide-react";

const CARD = {
  da_ritirare: { label: "Da ritirare", icon: ShoppingCart, color: "text-amber-400", ring: "border-amber-500/30" },
  ritirato: { label: "In transito", icon: Truck, color: "text-blue-400", ring: "border-blue-500/30" },
  arrivato: { label: "Arrivati", icon: PackageCheck, color: "text-emerald-400", ring: "border-emerald-500/30" },
  posteggi: { label: "Posteggi", icon: Store, color: "text-slate-300", ring: "border-slate-700" },
  bolle: { label: "Bolle", icon: ReceiptText, color: "text-purple-400", ring: "border-purple-500/30" },
  utenti: { label: "Team", icon: Users, color: "text-slate-300", ring: "border-slate-700" },
};

export default function Dashboard() {
  const { text } = useSettings();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const hour = new Date().getHours();
  const greet = hour < 12 ? "Buongiorno" : hour < 18 ? "Buon pomeriggio" : "Buonasera";

  return (
    <div className="animate-fade-up">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">{ROLE_LABELS[user.role]}</p>
        <h1 data-testid="dashboard-title" className="font-display font-black text-4xl sm:text-5xl text-slate-50 tracking-tight">
          {greet}, {user.name?.split(" ")[0]}.
        </h1>
        <p className="text-slate-400 mt-2">{text("dashboard_subtitle")}</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {["da_ritirare", "ritirato", "arrivato", "posteggi", "bolle", "utenti"].map((k) => {
          const c = CARD[k];
          const Icon = c.icon;
          return (
            <div
              key={k}
              data-testid={`stat-${k}`}
              className={`bg-slate-900/50 border ${c.ring} rounded-md p-5 flex flex-col gap-3`}
            >
              <div className="flex items-center justify-between">
                <span className="text-xs uppercase tracking-wider text-slate-400">{c.label}</span>
                <Icon className={`w-5 h-5 ${c.color}`} />
              </div>
              <span className="font-display font-black text-4xl text-slate-50 font-mono-plex">
                {stats ? stats[k] : "–"}
              </span>
            </div>
          );
        })}
      </div>

      <div className="mt-4 bg-slate-900/50 border border-emerald-500/30 rounded-md p-6 flex items-center justify-between">
        <div>
          <span className="text-xs uppercase tracking-wider text-slate-400">Totale acquisti registrati (bolle)</span>
          <div className="font-display font-black text-4xl text-emerald-400 font-mono-plex mt-1">
            € {stats ? stats.totale_acquisti.toLocaleString("it-IT", { minimumFractionDigits: 2 }) : "–"}
          </div>
        </div>
        <Euro className="w-10 h-10 text-emerald-500/50" />
      </div>
    </div>
  );
}
